import { z } from 'zod';
import { isIsoDate } from '../dates.js';

/** Identifiant (UUID), CDC §3.1. */
export const Uuid = z.uuid();

/** Date métier `AAAA-MM-JJ`. */
export const IsoDate = z.string().refine(isIsoDate, { message: 'Date attendue au format AAAA-MM-JJ' });

/** Horodatage ISO 8601 (champs `...At`). */
export const IsoDateTime = z.iso.datetime({ offset: true });

/** Montant en centimes (entier). */
export const Cents = z.int();

/** Adresse e-mail, normalisée en minuscules. */
export const Email = z
  .string()
  .trim()
  .toLowerCase()
  .pipe(z.email({ message: 'Adresse e-mail invalide' }));

/** Liste paginée, CDC §3.1. */
export function paginated<T extends z.ZodType>(item: T) {
  return z.object({ items: z.array(item), nextCursor: z.string().nullable() });
}
